import * as Mod1 from "./discourse/admin-chat-integration-plugin-route-map";
import * as Mod2 from "./discourse/initializers/chat-integration-admin-plugin-configuration-nav";
import * as Mod3 from "./discourse/public-route-map";
import * as Mod4 from "./discourse/routes/transcript";
const compatModules = {
  "discourse/admin-chat-integration-plugin-route-map": Mod1,
  "discourse/initializers/chat-integration-admin-plugin-configuration-nav": Mod2,
  "discourse/public-route-map": Mod3,
  "discourse/routes/transcript": Mod4,
};
export { compatModules };
export default compatModules;
